function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M38.719,0H1.314A1.307,1.307,0,0,0,0,1.3V51.167a1.307,1.307,0,0,0,1.314,1.3H38.719a1.307,1.307,0,0,0,1.314-1.3V1.3A1.307,1.307,0,0,0,38.719,0Z",
  fill: "#d3dbeb"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path-2",
  "data-name": "Path",
  d: "M.908,0A.913.913,0,0,0,0,.916V48.179a.913.913,0,0,0,.908.916H36.2a.913.913,0,0,0,.908-.916V.916A.913.913,0,0,0,36.2,0Z",
  transform: "translate(1.465 1.444)",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path-3",
  "data-name": "Path",
  d: "M.608,0A.636.636,0,0,0,0,.66V7.041a.636.636,0,0,0,.608.66H32.1a.636.636,0,0,0,.608-.66V.66A.636.636,0,0,0,32.1,0Z",
  transform: "translate(3.906 3.851)",
  fill: "#e9edf5"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path-4",
  "data-name": "Path",
  d: "M.608,0A.617.617,0,0,0,0,.624V14.778a.617.617,0,0,0,.608.624H32.1a.617.617,0,0,0,.608-.624V.624A.617.617,0,0,0,32.1,0Z",
  transform: "translate(3.906 14.921)",
  fill: "#e9edf5"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  width: 24.899,
  height: 1.444,
  transform: "translate(7.811 5.295)",
  fill: "#fff"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  "data-name": "Rectangle",
  width: 24.899,
  height: 0.481,
  transform: "translate(7.811 8.086)",
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-3",
  "data-name": "Rectangle",
  width: 24.899,
  height: 0.481,
  transform: "translate(7.811 9.626)",
  fill: "#fff"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "Path-5",
  "data-name": "Path",
  d: "M16.521,12.033H27.949a.368.368,0,0,0,.34-.229.374.374,0,0,0-.08-.4L20.9,4.021a.366.366,0,0,0-.52,0L18.556,5.856a.767.767,0,0,1-1.091,0L11.769.109a.366.366,0,0,0-.52,0L.108,11.349a.374.374,0,0,0-.08.4.368.368,0,0,0,.34.229H16.536Z",
  transform: "translate(5.859 18.29)",
  fill: "#fff"
});

var _ref10 = /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  cx: 1.465,
  cy: 1.444,
  rx: 1.465,
  ry: 1.444,
  transform: "translate(7.323 16.846)",
  fill: "#fff"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "Path-6",
  "data-name": "Path",
  d: "M.608,0A.617.617,0,0,0,0,.624V14.778a.617.617,0,0,0,.608.624H32.1a.617.617,0,0,0,.608-.624V.624A.617.617,0,0,0,32.1,0Z",
  transform: "translate(3.906 33.211)",
  fill: "#e9edf5"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  id: "Path-7",
  "data-name": "Path",
  d: "M16.521,12.033H27.949a.368.368,0,0,0,.34-.229.374.374,0,0,0-.08-.4L20.9,4.021a.366.366,0,0,0-.52,0L18.556,5.856a.766.766,0,0,1-1.091,0L11.769.108a.366.366,0,0,0-.52,0L.108,11.349a.374.374,0,0,0-.08.4.368.368,0,0,0,.34.229H16.536Z",
  transform: "translate(5.859 36.58)",
  fill: "#fff"
});

var _ref13 = /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval-2",
  "data-name": "Oval",
  cx: 1.465,
  cy: 1.444,
  rx: 1.465,
  ry: 1.444,
  transform: "translate(7.323 35.136)",
  fill: "#fff"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  id: "Path-8",
  "data-name": "Path",
  d: "M.929,0A.921.921,0,0,0,0,.912V51.553a.921.921,0,0,0,.929.912H39.105a.921.921,0,0,0,.929-.912V.912A.921.921,0,0,0,39.105,0Z",
  transform: "translate(13.67 11.552)",
  fill: "#d3dbeb"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  id: "Path-9",
  "data-name": "Path",
  d: "M.908,0A.917.917,0,0,0,0,.924V48.652a.917.917,0,0,0,.908.924H36.2a.917.917,0,0,0,.908-.924V.924A.917.917,0,0,0,36.2,0Z",
  transform: "translate(15.135 12.996)",
  fill: "#fff"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  id: "Path-10",
  "data-name": "Path",
  d: "M.408,0A.389.389,0,0,0,0,.365V2.041a.389.389,0,0,0,.408.365H24.491a.389.389,0,0,0,.408-.365V.365A.389.389,0,0,0,24.491,0Z",
  transform: "translate(20.505 19.734)",
  fill: "#007bff"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  id: "Path-11",
  "data-name": "Path",
  d: "M.1,0A.1.1,0,0,0,0,.105V.858A.1.1,0,0,0,.1.963H24.31a.1.1,0,0,0,.1-.105V.105A.1.1,0,0,0,24.31,0Z",
  transform: "translate(20.993 25.991)",
  fill: "#eaf0fb"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  id: "Path-12",
  "data-name": "Path",
  d: "M.1,0A.1.1,0,0,0,0,.105V.858A.1.1,0,0,0,.1.963H24.31a.1.1,0,0,0,.1-.105V.105A.1.1,0,0,0,24.31,0Z",
  transform: "translate(20.993 28.398)",
  fill: "#eaf0fb"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  id: "Path-13",
  "data-name": "Path",
  d: "M.1,0A.1.1,0,0,0,0,.105V.858A.1.1,0,0,0,.1.963H24.31a.1.1,0,0,0,.1-.105V.105A.1.1,0,0,0,24.31,0Z",
  transform: "translate(20.993 30.805)",
  fill: "#eaf0fb"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  id: "Path-14",
  "data-name": "Path",
  d: "M.1,0A.1.1,0,0,0,0,.105V.858A.1.1,0,0,0,.1.963H24.31a.1.1,0,0,0,.1-.105V.105A.1.1,0,0,0,24.31,0Z",
  transform: "translate(20.993 35.136)",
  fill: "#eaf0fb"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  id: "Path-15",
  "data-name": "Path",
  d: "M.1,0A.1.1,0,0,0,0,.105V.858A.1.1,0,0,0,.1.963H24.31a.1.1,0,0,0,.1-.105V.105A.1.1,0,0,0,24.31,0Z",
  transform: "translate(20.993 37.543)",
  fill: "#eaf0fb"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  id: "Path-16",
  "data-name": "Path",
  d: "M.1,0A.1.1,0,0,0,0,.105V.858A.1.1,0,0,0,.1.963H24.31a.1.1,0,0,0,.1-.105V.105A.1.1,0,0,0,24.31,0Z",
  transform: "translate(20.993 39.95)",
  fill: "#eaf0fb"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  id: "Path-17",
  "data-name": "Path",
  d: "M.1,0A.1.1,0,0,0,0,.105V.858A.1.1,0,0,0,.1.963H24.31a.1.1,0,0,0,.1-.105V.105A.1.1,0,0,0,24.31,0Z",
  transform: "translate(20.993 42.356)",
  fill: "#eaf0fb"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  id: "Path-18",
  "data-name": "Path",
  d: "M.1,0A.1.1,0,0,0,0,.105V.858A.1.1,0,0,0,.1.963H24.31a.1.1,0,0,0,.1-.105V.105A.1.1,0,0,0,24.31,0Z",
  transform: "translate(20.993 44.763)",
  fill: "#eaf0fb"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  id: "Path-19",
  "data-name": "Path",
  d: "M.1,0A.1.1,0,0,0,0,.105V.858A.1.1,0,0,0,.1.963H24.31a.1.1,0,0,0,.1-.105V.105A.1.1,0,0,0,24.31,0Z",
  transform: "translate(20.993 47.17)",
  fill: "#eaf0fb"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  id: "Path-20",
  "data-name": "Path",
  d: "M.1,0A.1.1,0,0,0,0,.105V.858A.1.1,0,0,0,.1.963H24.31a.1.1,0,0,0,.1-.105V.105A.1.1,0,0,0,24.31,0Z",
  transform: "translate(20.993 49.576)",
  fill: "#eaf0fb"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  id: "Path-21",
  "data-name": "Path",
  d: "M.1,0A.1.1,0,0,0,0,.105V.858A.1.1,0,0,0,.1.963H24.31a.1.1,0,0,0,.1-.105V.105A.1.1,0,0,0,24.31,0Z",
  transform: "translate(20.993 51.983)",
  fill: "#eaf0fb"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  id: "Path-22",
  "data-name": "Path",
  d: "M.1,0A.1.1,0,0,0,0,.105V.858A.1.1,0,0,0,.1.963H24.31a.1.1,0,0,0,.1-.105V.105A.1.1,0,0,0,24.31,0Z",
  transform: "translate(20.993 54.389)",
  fill: "#eaf0fb"
});

var _ref29 = /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval-3",
  "data-name": "Oval",
  cx: 7.03,
  cy: 6.931,
  rx: 7.03,
  ry: 6.931,
  transform: "translate(43.939 53.138)",
  fill: "#007bff"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  id: "Path-23",
  "data-name": "Path",
  d: "M2.572,6.353,0,3.526l1.5-.995L2.713,3.87,6.95,0,8.2,1.271,2.572,6.353Z",
  transform: "translate(46.869 56.796)",
  fill: "#fff"
});

var SvgDragger = function SvgDragger(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "graphic_upload_document",
    "data-name": "graphic / upload document",
    width: 58,
    height: 67,
    viewBox: "0 0 58 67",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDragger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dragger.fe0a6d05.svg";
export { ForwardRef as ReactComponent };